module.exports = __webpack_public_path__ + "static/media/logoF.b3f18d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoF.png
// module id = 1621
// module chunks = 0